import { useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { translate } from '../i18n';
import { usePosts } from '../hooks/usePosts';
import RichText from '../components/RichText';

const formatDate = (dateString: string, locale: string): string => {
  try {
    const date = new Date(dateString);
    return date.toLocaleDateString(locale === 'zh' ? 'zh-CN' : 'en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  } catch {
    return dateString;
  }
};

const StoriesPage = () => {
  const { locale } = useLanguage();
  const { posts, loading, error } = usePosts();
  const [selectedId, setSelectedId] = useState<string | null>(null);

  const selectedPost = selectedId
    ? posts.find((p) => p.id === selectedId)
    : posts[0] ?? null;

  if (loading) {
    return (
      <div className="stories-page">
        <p className="empty-state">{translate(locale, 'storiesLoadingState')}</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="stories-page">
        <p className="empty-state">{translate(locale, 'storiesErrorState')}</p>
      </div>
    );
  }

  if (posts.length === 0) {
    return (
      <div className="stories-page">
        <p className="empty-state">{translate(locale, 'storiesEmptyState')}</p>
      </div>
    );
  }

  return (
    <div className="stories-page">
      <div className="stories-layout">
        <aside className="stories-sidebar">
          <h2 className="stories-sidebar__title">{translate(locale, 'stories')}</h2>
          <ul className="stories-list">
            {posts.map((post) => (
              <li key={post.id}>
                <button
                  className={`stories-list__item${selectedPost?.id === post.id ? ' stories-list__item--active' : ''}`}
                  onClick={() => setSelectedId(post.id)}
                >
                  <span className="stories-list__item-title">{post.title[locale]}</span>
                  <span className="stories-list__item-date">
                    {formatDate(post.createdAt, locale)}
                  </span>
                </button>
              </li>
            ))}
          </ul>
        </aside>

        <article className="stories-content">
          {selectedPost && (
            <>
              <header className="stories-content__header">
                <h1>{selectedPost.title[locale]}</h1>
                <time className="stories-content__date">
                  {formatDate(selectedPost.createdAt, locale)}
                </time>
              </header>
              <RichText
                content={selectedPost.content[locale]}
                className="stories-content__body"
              />
            </>
          )}
        </article>
      </div>
    </div>
  );
};

export default StoriesPage;
